import VentaPorProducto from './VentaPorProducto'

export default VentaPorProducto
